import Vue from "vue";
import App from "@/App.vue";
import router from "@/core/router";
import store from "@/core/store";
import vuetify from "@/core/plugins/vuetify";
import i18n from "@/localization/i18n";
import tokenInterceptor from "@/core/services/interceptors";
import axios from "axios";
import AppUtils from "@/app/utils";
import "@/core/assets/sass/style.scss";
import { sync } from "vuex-router-sync";

Vue.config.productionTip = false;

axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;

const appConfig = AppUtils.getConfig();
Vue.prototype.$appConfig = appConfig;

Vue.prototype.$rastless = axios.create({
  baseURL: process.env.VUE_APP_RASTLESS_URL
});

Vue.prototype.$credit = axios.create({
  baseURL: process.env.VUE_APP_CREDIT_URL
});

import Keycloak from "keycloak-js";

const keycloak = new Keycloak({
  url: process.env.VUE_APP_KC_URL,
  realm: process.env.VUE_APP_REALM,
  clientId: "noosacoasts"
});

keycloak
  .init({
    onLoad: "check-sso",
    pkceMethod: "S256",
    checkLoginIframe: false,
    redirectUri: window.location.origin
  })
  .then(authenticated => {
    Vue.prototype.$keycloak = keycloak;

    if (authenticated) {
      // // Set up token refresh

      // Add fullName and userName properties for backward compatibility
      keycloak.fullName = `${keycloak.tokenParsed.given_name} ${keycloak.tokenParsed.family_name}`;
      keycloak.userName = keycloak.tokenParsed.preferred_username;

      // Make Keycloak available globally
      Vue.prototype.$keycloak = keycloak;
      tokenInterceptor();
      // Start Vue app
    }

    sync(store, router);
    new Vue({
      router,
      store,
      vuetify,
      i18n,
      render: h => h(App)
    }).$mount("#app");
  })
  .catch(error => {
    console.error("Keycloak init error:", error);
  });
